// Components - UI
import Splitter from '@/components/ui/Splitter/Splitter.vue';
import IssueBadge from '@/components/ui/IssueBadge/IssueBadge.vue';
import ReviewMood from '@/components/ui/ReviewMood/ReviewMood.vue';
import ReviewStars from '@/components/ui/ReviewStars/ReviewStars.vue';
import WashroomIcon from '@/components/ui/WashroomIcon/WashroomIcon.vue';
import Scroller from '@/components/ui/Scroller/Scroller.vue';

// Services
import ReviewsService from '@/services/ReviewsService.js';
import RetailersService from '@/services/RetailersService.js';
import WashroomsService from '@/services/WashroomsService.js';

// EventBus
import { EventBus } from '@/EventBus.js';

export default {

  name: 'reviews-detail',

  components: {
    IssueBadge,
    ReviewStars,
    ReviewMood,
    WashroomIcon,
    Splitter,
    Scroller
  },

  data: function() {
    return {
      review: null,
      retailer: null,
      washroom: null,
      reviews: []
    }
  },

  created: function() {
    let id = this.$route.params.id;

    ReviewsService.getById(id)
      .then((res) => {
        this.review = res.data;

        // Get Retailer Info
        RetailersService.getById(this.review.retailer)
          .then((res) => {
            this.retailer = res.data;
          })
          .catch((err) => {
            console.error('RetailersService(err)', err);
          });

        // Get Washroom Info
        WashroomsService.getById(this.review.washroom)
          .then((res) => {
            this.washroom = res.data;
          })
          .catch((err) => {
            console.error('WashroomsService(err)', err);
          });

        // Get Reviews for Retailer
        ReviewsService.getAll({retailer: this.review.retailer})
          .then((res) => {
            this.reviews = res.data;
          })
          .catch((err) => {
            console.error('ReviewsService(err)', err);
          });
      })
      .catch((err) => {
        console.error('ReviewsService(err)', err);
      });
  },

  mounted: function() {

  },

  beforeDestroy: function() {

  },

  methods: {
    intToDecimal: function(integer) {
      return integer + '.0';
    }
  },

  computed: {
    filteredIssues: function () {
      if(localStorage.getItem('userGroup') == 'service-providers') {
        let serviceProviderId = localStorage.getItem('parentId');

        let openIssueStatus = ['confirmed', 'resolution-in-progress', 'resolution-awaiting-approval', 'resolution-denied'];

        return this.review.issues.filter((i) => (i.serviceProvider == serviceProviderId && openIssueStatus.indexOf(i.status) > -1) || i.serviceProvider == null);
      }
      return this.review.issues;
    },

    images: function() {
      let images = [];

      for(let i in this.filteredIssues) {
        if(this.filteredIssues[i].s3ImageUrl) {
          images.push(process.env.s3Url + '/img/issues/' + this.filteredIssues[i].s3ImageUrl);
        }
      }

      return images;
    },

    numericalRating: function() {
      return Math.round(this.review.overallRating * 10) / 10;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/ReviewsDetail/ReviewsDetail.js